import { createSelector } from 'reselect';
import { VISUALISATIONS } from '../plannerConfig';

export const getVisualisations = state => state[VISUALISATIONS].data;

export const getParsedVisualisationsAsObject = createSelector(
  getVisualisations,
  visualisationData => visualisationData.reduce((acc, curr) => ({
    ...acc,
    [curr.name]: { ...curr, template: JSON.parse(curr.template) },
  }), {}),
);
